
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import {
    IonPopover, IonDatetime,
    IonButtons,
    IonBackButton,
    IonAccordionGroup,
    IonAccordion,
    IonModal,
    IonGrid,
    IonFooter,
    IonRow,
    IonCol,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact,
    IonButton,
    IonRouterContext,
    IonRouteProps,
    IonLoading,
    IonToast,
    IonCard,
    IonFabButton,
    IonInfiniteScroll,
    IonSegment,
    IonSegmentButton,
    IonList,
    IonItem,
    IonText,
    IonFab,
    IonSearchbar,
    IonTextarea,
    IonInfiniteScrollContent,
    IonCheckbox,
    withIonLifeCycle, IonRefresher, IonRefresherContent
} from '@ionic/react';

import { funnel, arrowUp, business, barcode, person, podium, closeOutline, search, add, ticketOutline, receiptOutline, personOutline, callOutline, logoWhatsapp, locationOutline, mapOutline } from 'ionicons/icons';
import { DebounceInput } from 'react-debounce-input';
import Moment from 'react-moment';
import moment from 'moment';
import { Capacitor } from '@capacitor/core';

import { getContact, getPermissions, getShoppingCart, getTransactions, getLoginApp, getTransactionPayments } from '../../utils/functions';
import PosActions from '../../actions/PosActions';

const options2 = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);
import Select from 'react-select';
import { Printer } from '@bcyesil/capacitor-plugin-printer';

interface IProps {
    get_: any;
    setData_: any;
    post_: any;
}

interface IState {
    paymentsData: any;
    pageSize: any;
    pages: any;
    loadmore_data_pagination: any;
    current_count_data: any;
    total_rows: any;
    searchText: any;
    data_login_ari_app: any;

    currencyprimary: any;
    primary_label: any;

    currencysecondary: any;
    secondary_label: any;
    secondary_operation: any;
    cash_register_util: any;
    payment_types_is_secondary: any;
    payment_types_key: any;
    isOpenDateStart: any;
    DateStart: any;
    isOpenDateEnd: any;
    DateEnd: any;
    isOpenModalFilterDate: any;
    id_payment: any;
    ruta_ids: any;
    rutas: any;
taxes_impositive: any;
}

class PaymentsList extends React.Component<IProps, IState> {
    contentRef: React.RefObject<HTMLIonContentElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;

    constructor(props: any) {
        super(props)
        this.contentRef = React.createRef<HTMLIonContentElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();

        this.state = {
            loadmore_data_pagination: props.loadmore_data_pagination,
            current_count_data: props.current_count_data,
            paymentsData: props.paymentsData,
            pageSize: props.pageSize,
            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            data_login_ari_app: props.data_login_ari_app,

            currencyprimary: props.currencyprimary,
            primary_label: props.primary_label,
            currencysecondary: props.currencysecondary,
            secondary_label: props.secondary_label,
            secondary_operation: props.secondary_operation,

            cash_register_util: props.cash_register_util,
            payment_types_is_secondary: props.payment_types_is_secondary,
            payment_types_key: props.payment_types_key,
            isOpenDateStart: props.isOpenDateStart,
            DateStart: props.DateStart,
            isOpenDateEnd: props.isOpenDateEnd,
            DateEnd: props.DateEnd,
            isOpenModalFilterDate: props.isOpenModalFilterDate,
            id_payment: props.id_payment,
            ruta_ids: props.ruta_ids,
            rutas: props.rutas,

            taxes_impositive: props.taxes_impositive

        }
    }

    async componentDidMount() {

        let data_login_ari_app: any = !getLoginApp() ? [] : getLoginApp();

        this.setState({
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            loadmore_data_pagination: true,
            data_login_ari_app: data_login_ari_app,
            isOpenDateStart: false,
            DateStart: new Date().toISOString(),
            isOpenDateEnd: false,
            DateEnd: new Date().toISOString(),
            isOpenModalFilterDate: false,
            id_payment: null,
            ruta_ids: null
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {

        this.setState({
            paymentsData: nextProps.data.data_pagin_paymentsData && nextProps.data.data_pagin_paymentsData ? nextProps.data.data_pagin_paymentsData : [],
            pages: nextProps.data.paymentsData && nextProps.data.paymentsData.pages ? nextProps.data.paymentsData.pages : 0,
            total_rows: nextProps.data.paymentsData && nextProps.data.paymentsData.total_rows ? nextProps.data.paymentsData.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_paymentsData ? nextProps.data.data_pagin_paymentsData.length : 0,

            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',
            primary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.primary_label : 'primary',
            currencysecondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencysecondary : '',
            secondary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.secondary_label : 'secondary',
            secondary_operation: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.secondary_operation : '*',
            cash_register_util: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util : null,
            payment_types_key: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.payment_types_key : [],
            rutas: nextProps.data.data_default && nextProps.data.data_default.rutas ? nextProps.data.data_default.rutas : [],
            payment_types_is_secondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.payment_types_is_secondary : [],
            taxes_impositive: nextProps.data.data_default && nextProps.data.data_default.taxes_impositive ? nextProps.data.data_default.taxes_impositive : [],

        });

        if (nextProps.data.view_active == "customer_dues/get_customer_abonos") {
            if (nextProps.data.refresh_list && !nextProps.data.paymentDatalist) {
                this.buttomup();
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }

            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.paymentDatalist) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }

            if (nextProps.data.response && nextProps.data.response.success && nextProps.data.response.receipt) {

                setTimeout(this.printTransaction.bind(this, nextProps.data.response.receipt), 100);

            }
        }



    }

    printTransaction(html: any) {
        if (Capacitor.isNativePlatform()) {
            Printer.print({ content: html, name: 'lorem-filename', orientation: 'portrait' })
                .then((res: any) => {
                    this.props.setData_({ response: {}, simpleToast: false, loading: { Msg: 'Cargando...', isOpen: false } });

                })
                .catch((err: any) => {

                    this.props.setData_({ response: {}, simpleToast: false, loading: { Msg: 'Cargando...', isOpen: false } });
                });
        } else {
            // Para navegador web
            const printFrame = document.createElement('iframe');
            printFrame.style.position = 'fixed';
            printFrame.style.right = '0';
            printFrame.style.bottom = '0';
            printFrame.style.width = '0';
            printFrame.style.height = '0';
            printFrame.style.border = '0';
            printFrame.srcdoc = html;
            // Insertar el iframe en el div print-area en lugar de document.body
            const printArea = document.getElementById('print-area');
            if (printArea) {
                printArea.appendChild(printFrame);
            } else {
                document.body.appendChild(printFrame);
            }

            printFrame.onload = () => {
                printFrame.contentWindow?.focus();
                printFrame.contentWindow?.print();
                setTimeout(() => {
                    if (printFrame.parentNode === document.body) {
                        document.body.removeChild(printFrame);
                    } else if (printFrame.parentNode) {
                        printFrame.parentNode.removeChild(printFrame);
                    }
                }, 3000);
            };

            this.props.setData_({ response: {}, simpleToast: false });
        }
    }

    getDataPaginInit() {
        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.data_login_ari_app.id,
            typeOption: 'get_customer_abonos',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'customer_dues/get_customer_abonos',
            start: moment(this.state.DateStart, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
            end: moment(this.state.DateEnd, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
            id_payment: this.state.id_payment,
            ruta_ids: this.state.ruta_ids,

        }, "api/get_customer_abonos");
    }

    buttomup() {
        if (this.contentRef.current) {
            this.contentRef.current.scrollToTop();
        }
    }
    sendprintTransaction(row: any) {
        this.props.get_({
            typeOption: 'print_payment',
            id: row.id,
            user_id: this.state.data_login_ari_app.id,
            view_active: 'customer_dues/get_customer_abonos',
            contact_id_id: row.contact_id_id,
        }, "api/print_payment");
    }
    render_contacts(row: any, key: any) {
        let data_permission = getPermissions();
        let payment_types_is_secondary = this.state.payment_types_is_secondary;
        let currencyprimary = this.state.currencyprimary;
        let currencysecondary = this.state.currencysecondary;
        let payment_types_key = this.state.payment_types_key;
        return (
            <IonCard key={key + "_contact"}>
                <IonItem lines="none">
                    <IonIcon slot="start" color='#28bb50' icon={personOutline} />
                    <IonLabel>
                        <h2>
                            {row.customer_name} ({row.contact_id})
                        </h2>
                    </IonLabel>
                    <IonButton slot="end" color={'tertiary'} onClick={() => this.sendprintTransaction(row)}>
                        <IonIcon slot="icon-only" icon={ticketOutline} />
                    </IonButton>
                </IonItem>
                <IonItem lines="none">
                    <IonLabel>
                        <h2>
                            <strong>Fecha: </strong>{row.paid_on ? moment(row.paid_on).format("DD-MM-YYYY HH:mm") : ''} <br />
                            <strong>Ruta: </strong>{row.ruta ? row.ruta : 'Sin ruta'} <br />
                            <strong>note: </strong>{row.note ? row.note : ''} <br />
                            <strong>#: </strong>{row.payment_ref_no ? row.payment_ref_no : ''} <br />

                            <strong>Metodo de Pago : </strong>{(payment_types_key && payment_types_key[row.method]) ?? ''}<br />
                            {
                                payment_types_is_secondary && payment_types_is_secondary[row.method] && payment_types_is_secondary[row.method] == 1 ?
                                    <>
                                        <strong>Monto : </strong>{_numberFormat.format(row.secondary).replace("$", currencysecondary)}
                                    </> :
                                    <>
                                        <strong>Monto : </strong>{_numberFormat.format(row.amount).replace("$", currencyprimary)}
                                    </>
                            }
                        </h2>
                    </IonLabel>
                </IonItem>
            </IonCard>
        );
    }

    handleRefresh(event: any) {
        this.setState({
            pages: 0,
            pageSize: 10,
        });
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    changeFilterDate(e: any) {

        let DateStart: any = null;
        let DateEnd: any = null;

        if (e.target.value == 'hoy') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'ayer') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
        } else if (e.target.value == 'ultimo_7') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(7, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'este_mes') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('month').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('month').format("YYYY-MM-DD");
        } else if (e.target.value == 'este_ano') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        } else if (e.target.value == 'ano_pasado') {
            DateStart = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        }

        this.setState({
            isOpenDateStart: false,
            DateStart: DateStart,
            isOpenDateEnd: false,
            DateEnd: DateEnd,
            isOpenModalFilterDate: false,
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });

        setTimeout(this.getDataPaginInit.bind(this), 100);
    }
    handleChangeDefault(event: any) {
        console.log(event);
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        });
        this.setState({
            pages: 0,
            pageSize: 10
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);

    }
    render() {
        const { ruta_ids, rutas, id_payment, isOpenDateEnd, DateEnd, isOpenModalFilterDate, isOpenDateStart, DateStart, searchText, payment_types_is_secondary, primary_label, paymentsData, currencyprimary, currencysecondary, cash_register_util } = this.state;
        let data_render_payments = [];

        if (paymentsData && paymentsData.length > 0) {
            data_render_payments = [];
            data_render_payments = paymentsData.map((val: any, key: any) =>
                this.render_contacts(val, key)
            );
        };

        return (
            <>
                <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonRow>
                    <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                        <IonButton
                            expand="full"
                            onClick={(e: any) => {
                                e.persist();
                                this.setState({
                                    isOpenDateStart: true,
                                    pages: 0,
                                    pageSize: 10,
                                    loadmore_data_pagination: true
                                });
                            }}
                        >
                            Inicio :
                            <Moment
                                date={DateStart}
                                format="DD-MM-YYYY"
                            />
                        </IonButton>
                        <IonPopover
                            isOpen={isOpenDateStart}
                            onDidDismiss={() =>
                                this.setState({
                                    isOpenDateStart: false,
                                    pages: 0,
                                    pageSize: 10,
                                    loadmore_data_pagination: true
                                })}
                        >
                            <IonDatetime
                                presentation="date"
                                value={moment(DateStart, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                onIonChange={(e: any) => {
                                    this.setState({ DateStart: e.detail.value, isOpenDateEnd: false });
                                    setTimeout(this.getDataPaginInit.bind(this), 1000);
                                }}
                            ></IonDatetime>
                        </IonPopover>
                    </IonCol>
                    <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                        <IonButton color='primary' expand="full" onClick={(e: any) => {
                            e.persist();
                            this.setState({ isOpenModalFilterDate: true });
                        }}>
                            <IonIcon icon={funnel}></IonIcon>
                        </IonButton>
                        <IonPopover
                            isOpen={isOpenModalFilterDate}
                            onDidDismiss={() =>
                                this.setState({ isOpenModalFilterDate: false })}
                        >
                            <IonList inset={true}>
                                <IonItem
                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'hoy' } })}
                                >
                                    <IonLabel>Hoy</IonLabel>
                                </IonItem>
                                <IonItem
                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ayer' } })}>
                                    <IonLabel>Ayer</IonLabel>
                                </IonItem>
                                <IonItem
                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ultimo_7' } })}>
                                    <IonLabel>Los Ultimos 7 Dias</IonLabel>
                                </IonItem>
                                <IonItem
                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_mes' } })}>
                                    <IonLabel>Este Mes</IonLabel>
                                </IonItem>
                                <IonItem
                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_ano' } })}>
                                    <IonLabel>Este Año</IonLabel>
                                </IonItem>
                                <IonItem
                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ano_pasado' } })}>
                                    <IonLabel>El Año Pasado</IonLabel>
                                </IonItem>
                            </IonList>
                        </IonPopover>
                    </IonCol>
                    <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                        <IonButton
                            expand="full"
                            onClick={(e: any) => {
                                e.persist();
                                this.setState({ isOpenDateEnd: true });
                            }}
                        >
                            Fin :
                            <Moment
                                date={DateEnd}
                                format="DD-MM-YYYY"
                            />
                        </IonButton>
                        <IonPopover
                            isOpen={isOpenDateEnd}
                            onDidDismiss={() =>
                                this.setState({ isOpenDateEnd: false })}
                        >
                            <IonDatetime
                                presentation="date"
                                value={moment(DateEnd, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                onIonChange={(e: any) => {
                                    this.setState({ DateEnd: e.detail.value, isOpenDateEnd: false });
                                    setTimeout(this.getDataPaginInit.bind(this), 1000);
                                }}

                            ></IonDatetime>
                        </IonPopover>
                    </IonCol>
                    <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                        <div style={{ display: "none" }}>
                            <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                        </div>
                    </IonCol>
                    <IonCol col-12 size='12' class='divflex'>
                        <IonIcon icon={search} className='iconseach'></IonIcon>

                        <DebounceInput
                            className='btn_search'
                            placeholder={'Buscar cliente por Nombre/Código'}
                            minLength={2}
                            debounceTimeout={2000}
                            value={searchText}
                            onChange={e => this.setSearchText(e)} />
                    </IonCol>
                    <IonCol col-12 size='12'>
                        {
                            cash_register_util && cash_register_util.payment_types && cash_register_util.payment_types.length > 0 ?
                                <Select
                                    onChange={(e: any) => this.handleChangeDefault({ target: { name: 'id_payment', value: e.value } })}
                                    placeholder="Metodos de Pago"
                                    name='id_payment'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={
                                        cash_register_util.payment_types.map((option: any) => (
                                            { label: option.label, value: option.id }
                                        ))
                                    }
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={id_payment ?
                                        cash_register_util && cash_register_util.payment_types && cash_register_util.payment_types.length > 0 ?
                                            { label: cash_register_util.payment_types.filter((item: any) => item.id == id_payment)[0].name, value: cash_register_util.payment_types.filter((item: any) => item.id == id_payment)[0].id }
                                            : null
                                        : null
                                    }
                                /> : null
                        }
                    </IonCol>
                    <IonCol col-12 size='12'>
                        {
                            rutas && rutas && rutas.length > 0 ?
                                <Select
                                    onChange={(e: any) => this.handleChangeDefault({ target: { name: 'ruta_ids', value: e } })}
                                    placeholder="Rutas"
                                    name='ruta_ids'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    isMulti={true}
                                    options={
                                        rutas.map((option: any) => (
                                            { label: option.name, value: option.id }
                                        ))
                                    }
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}

                                /> : null
                        }
                    </IonCol>
                    <IonCol size="12">
                        {data_render_payments}
                    </IonCol>
                </IonRow>

                <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                    onIonInfinite={(event) => {
                        this.getDataPaginInit();
                    }}
                >
                    <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                </IonInfiniteScroll>

            </>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
        post_: (fields: any, controller: string) => dispatch(PosActions.post_(fields, controller))
    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(PaymentsList));

